import React, { Component } from 'react'

import MainLayout from '../../mainLayout/index';
import {Link} from 'react-router-dom';

// import ProgramImage from './../../../assets/images/user.jpg';
import Select from 'react-select';
//moment import
import moment from "moment";


import FpgDisableIcon from '../../icons/fpgdisableicon';
import FpgpublishIcon from '../../icons/fpgpublishicon';
import FpgDeleteIcon from '../../icons/fpgdeleteicon';
import FpgeeditIcon from '../../icons/fpgediticon';
import PlusIcon from '../../icons/plusicon';
import service from "../../services";
import PopUpCustomAll from "../fpg/create/popUpCustomAll";
//Redux Connect
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { ActCreators } from "../../redux/bindActionCretor";
import ErrorPopUp from '../errorPopUp';
import Loader from '../loader';

let sub;

const mapStateToProps = (state) => ({
    notificationId:state.notificationId
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(ActCreators, dispatch);
};

class MobileView extends Component {
    constructor(props) {
        super(props)
    
        this.state = {
            notificationText:"",
            isView:false,
            MobileAppList: [],
            mobiledataFalse:false,
            sendNotification:false

             
            
        }
        this.apiserve = new service();
    }

    componentWillUnmount = () => {
        sub.unsubscribe();
     };
     
      componentDidMount = () => {
        //  this.getNotificationDetails();
         {
          this.props.notificationId &&
          this.getNotificationDetails();
          
        }
          this.apiserve.sendevent("admin|lastNotyUpdate",{});

         sub = this.apiserve.getevent().subscribe((response) => {
           switch (response.event) {
               case "admin|viewNoty":
                if (!response.error) { 
                    this.setState({
                        notificationText: response.data.notificationText,
                        emails: response.data.emails,
                        notificationText: response.data.film,
                        MobileAppList:response.data.docs,
                       
                    })
                   
                    }
                break;

            case "admin|sendNoty":
              if(!response.error){
                this.props.history.push('/notifications')
              } 
              else{
                this.setState({
                  errorPopup:true,
                  errorMsg: response.data.error ? response.data.error : response.data        
                })
            }
            break;
            case "admin|lastNotyUpdate":
              this.setState({
                  getLastUpdated:response.data[0]
              })
          break;
      
             default:
               break;
           }
         });
     };
 
     getNotificationDetails = () => {
         this.setState({
           loaderFlag: false,
           mobiledataFalse:true
       })
       var data={
        notificationId:this.props.notificationId,
        isView:true
       
       }
         this.apiserve.sendevent("admin|viewNoty", data);
       };
       
       editMobileAppList = () => {
        var data={
          notificationId:this.props.notificationId,
          isView:false
         
         }
           this.apiserve.sendevent("admin|viewNoty", data);
          this.setState({mobiledataFalse:false})
        this.props.history.push({
          pathname: "/notification-create",
        });
      };

      deleteFilm = () => {
        this.setState({
          deleteFilm:true
        })  
      }
    
      deleteFilmPopupYes = () => {
        this.apiserve.sendevent("admin|removeNoty", {
            notificationId:this.props.notificationId
        });
        this.props.history.push({
          pathname: "/notifications",
        });
      }
    
      publishFilm = () => {
        this.setState({
          publishFilm:true,
          sendNotification:true
        })  
      }
    
      publishFilmPopupYes = () => {
        this.apiserve.sendevent("admin|sendNoty", {
            notificationId:this.props.notificationId,
           
        });
      }
    
      disableFilm = () => {
        this.setState({
          disableFilm:true
        })  
      }
    
      disableFilmPopupYes = () => {
        this.apiserve.sendevent("admin|sendNoty", {
            notificationId:this.props.notificationId,
           
        });
      }

      clearAllForm = () => {
        this.setState({
            name: "",
            access: "",
            date: new Date(),
            hours: '7',
            minutes:"30",
            state:"AM",
            shortProgrammeFilms: [],
        })
        this.props.NotificationEditData('')
        this.props.history.push('/notification-create')
    }
    
    errorMsgPopup = () => {
      this.setState({
          errorPopup:false
      })  
    }

    closeAdminUser = () => {
      this.setState({
        deleteFilm: false,
        publishFilm: false,
        disableFilm: false,
      });
    };

getAlldetails = () => {
  var data = { filmId: this.props.filmEditId };
  this.apiserve.sendevent("film|getAllDetail", data);
};
  handleChange = (e) => {
    const {name,value} = e.target
    this.setState({
      [name]:value
    })
  }


    render() {
        const {MobileAppList,getLastUpdated,shortData,consumed,opted,
          total,awardWinneraAllowed,awardWinneraConsumed,catchUpAccessAllowed,catchUpAccessConsumed,
          catchUpTicketsAllowed,catchUpTicketsConsumed,lastUpdatedBy,lastUpdatedAt} = this.state
        var updateAt = new Date (getLastUpdated && getLastUpdated.updatedAt)
        var hour = moment(updateAt).tz("US/Mountain").format('h')
        var minutes = moment(updateAt).tz("US/Mountain").format('mm')
        var state = moment(updateAt).tz("US/Mountain").format('A')
        var updatedBy = getLastUpdated && getLastUpdated.updatedBy

        const {} = this.state
        var settings = {
          customPaging: function(i) {
              return (
                <a>{i + 1}</a>
              );
            },
          dots: true,
          arrows: false,
          infinite: true,
          speed: 500,
          slidesToShow: 1,
          slidesToScroll: 1
        };
        return (
            <React.Fragment>
                    <div className="right_side_wrapper relative">
                        <div className="bradcrumb disp_flex d_flex_justify_spacebt d_flex_align_center">
                            <ul className="disp_flex">
                            <li> Add / Edit Mobile Notification</li>
                               
                            </ul>
                            <Link className="add_page" onClick={(e)=>this.clearAllForm(e)}><PlusIcon /></Link>
                        </div>
                        <div className="back_date d_flex d_flex_align_center d_flex_justify_spacebt">
                            <Link className="back_link" to='/notifications'> <svg width="5" height="10" viewBox="0 0 5 10" fill="none"> <path d="M5 0L0 5L5 10V0Z" fill="black"/> </svg> Back To List</Link>
                            {this.state.getLastUpdated && this.state.getLastUpdated.updatedAt === undefined ? '' :
                              <p className="update_date">Last Update: {hour}:{minutes} {state} - {moment(updateAt).format('MM/DD/YYYY')}  </p>
                            }
                        </div>
                        <div className="fpg_tabcontent">
                          <div className="program_main d_flex">
                              <div className="program_left">
                                  
                               
                              </div>
                              <div className="program_right feature_col">
                                  <div className="fpg_edits_links d_flex d_flex_align_center">
                                  <Link className="d_flex d_flex_align_center d_flex_justify_center" 
                                    onClick={this.editMobileAppList}
                                  >
                                  <FpgeeditIcon />
                                  EDIT
                                  </Link>
                                  {MobileAppList && MobileAppList[0]?.status === "Sent"?
                                    <Link className="d_flex d_flex_align_center d_flex_justify_center" onClick={()=>this.publishFilm()}>
                                    <FpgpublishIcon /> Send
                                  </Link>
                                  :              
                                  <Link className="d_flex d_flex_align_center d_flex_justify_center" onClick={()=>this.publishFilm()}>
                                    <FpgpublishIcon /> Send
                                  </Link>
                                  }
                                  <Link className="d_flex d_flex_align_center d_flex_justify_center" onClick={()=>this.deleteFilm()}>
                                    <FpgDeleteIcon />
                                    DELETE
                                  </Link>
                                  </div>
                                  
                                  
                              </div>
                              <div className="screen_dates  mt_25" style={{margin:'0 auto  42px auto'}}>
                              <div className="data_list">
                                   {MobileAppList.map((item)=>{
                           
                       return(
                                      <ul>
                                        <li className="d_flex">
                                          <label style={{display:"inline-block",fontSize:'12px',lineHeight:'20px'}}>Notification Text</label>
                                          <span style={{display:"inline-block",fontSize:'14px',lineHeight:'20px',width:'200px',marginLeft:'40px'}}>{item && item?.notificationText}</span>
                                        </li>
                                        <li className="d_flex">
                                          <label style={{display:"inline-block",fontSize:'12px',lineHeight:'20px'}}>Send To</label>
                                          <span style={{display:"inline-block",fontSize:'14px',lineHeight:'20px',width:'90px',marginLeft:'90px'}}>{item && item?.totalUser}</span>
                                        </li>
                                        </ul>
                                       
                       
                        )})}
                     </div>
                     </div>
                          
                          </div>
                          {}
                          <div className="data_list">
                         {}
                            </div>
                        </div>
                    
                   
                  {this.state.loaderFlag ? (
                        <Loader />
                  ) : (
                          ""
                  )}

                    {this.state.errorPopup ? 
                            <ErrorPopUp
                            errorMsg={this.state.errorMsg}
                            errorMsgPopup={this.errorMsgPopup}
                            />    
                        : ''
                    }

                    {this.state.deleteFilm ? 
                        <PopUpCustomAll 
                          HeaderName = 'Delete?'
                          insideDetails = 'You are about to delete an item and this action is permanent'
                          insideData =  'Do you want to proceed?'
                          popupState = {this.closeAdminUser}
                          yesPopUp = {this.deleteFilmPopupYes}
                        />
                      :''}

                    {this.state.publishFilm ? 
                        <PopUpCustomAll 
                          HeaderName = 'Confirm Notification Send'
                          insideDetails = {`You are about to send the following mobile app notification to ${MobileAppList[0].totalUser} recipients: `}
                          insideMobileDetails={`${MobileAppList[0].notificationText}`}
                          insideData =  'Are you sure you want to send this mobile app notification?'
                          popupState = {this.closeAdminUser}
                          yesPopUp = {this.publishFilmPopupYes}
                          sendNotification={this.state.sendNotification}
                        />
                      :''}

                    {this.state.disableFilm ? 
                        <PopUpCustomAll 
                          HeaderName = 'Disable?'
                          insideDetails = 'You are about to disable an item, which will temporarily make it unavailable on the production site'
                          insideData =  'Do you want to proceed?'
                          popupState = {this.closeAdminUser}
                          yesPopUp = {this.disableFilmPopupYes}
                        />
                      :''}
                {/* Loader */}
                {this.state.loaderFlag ? (
                <Loader />
                  ) : (
                          ""
                )}
                </div>
            </React.Fragment>            
        )
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
  )(MobileView);
